import axios from 'axios';
export function MenuProject(id) {
    return axios.get(process.env.REACT_APP_API + "/api/projects/getbycategory.php?category=" + id);
}

export function GetImages(id) {
    return axios.get(process.env.REACT_APP_API + "/api/projects/getimagesactive.php?id=" + id);
}